
import { useContext } from "react";
import { Link } from "react-router-dom";
import UserContext from "../../contexts/UserContext";
import { textes } from "../../constants/textes";


export default function Retrait({retrait, position}) {
    // states
    const {user} = useContext(UserContext);


    // comportements


    // Affichage
    return (
        <tr style={{borderStyle: "none"}}>
            <td className="text-center">{position + 1}</td>
            <td>{retrait?.numtel}</td>
            <td>{retrait?.nom}</td>
            <td>{retrait?.montant} XAF</td>
            <td>{Number.parseFloat(retrait?.montantpercu)} XAF</td>
            <td>
                <span 
                    className={`badge ${
                        retrait.etat === 1 ? "badge-warning" : 
                        retrait.etat === 2 ? "badge-info" : 
                        retrait.etat === 3 ? "badge-success" : 
                        (retrait.etat === 4 || retrait.etat === 5) ? "badge-danger" : 
                        ""
                        } mt-2`
                    } 
                    style={{fontSize: 14}}>
                        {retrait?.etatdef}
                </span>
            </td>
            <td>{retrait?.datecrea.slice(0, 16).replace("T", " à ")}</td>
            <td className="text-center">
                {(user?.isFullAction || user?.isAdminAction || user?.isConsulterDemanderetrait) && 
                    <Link to={`/demande-retrait/${retrait?.code}`} data-toggle="tooltip" title={textes.fr.viewdmretratilabel} data-placement="left" className="btn-shadow-primary mr-2 ml-2 btn btn-sm btn-primary">
                        <i className="fa fa-eye"></i>
                    </Link>
                }
            </td>
        </tr>
    )
}